import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function CreateTripDialog({
  open,
  onOpenChange,
  activeShift,
  tripNumber,
  startDateText,
  form,
  setForm,
  creating,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="create-trip-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "'Cormorant Garamond', serif" }}>Opprett tur-record</DialogTitle>
          <DialogDescription className="text-xs">
            Skift {activeShift} · Tur {tripNumber} · Start {startDateText}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold mb-1 block">Namn *</label>
            <input
              value={form.name}
              onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
              placeholder={`Tur ${tripNumber} – Skift ${activeShift}`}
              className="w-full rounded-md border border-stone-200 px-3 py-2 text-sm focus:border-navy-800 focus:ring-1 focus:ring-navy-800 outline-none"
              data-testid="create-trip-name-input"
              autoFocus
            />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold mb-1 block">Budsjett (kr)</label>
            <input
              type="number"
              value={form.budget}
              onChange={(e) => setForm((f) => ({ ...f, budget: e.target.value }))}
              placeholder="50000"
              className="w-full rounded-md border border-stone-200 px-3 py-2 text-sm focus:border-navy-800 focus:ring-1 focus:ring-navy-800 outline-none"
              data-testid="create-trip-budget-input"
            />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold mb-1 block">Slutt-dato (valgfri)</label>
            <input
              type="date"
              value={form.end_date}
              onChange={(e) => setForm((f) => ({ ...f, end_date: e.target.value }))}
              className="w-full rounded-md border border-stone-200 px-3 py-2 text-sm focus:border-navy-800 focus:ring-1 focus:ring-navy-800 outline-none"
              data-testid="create-trip-end-date-input"
            />
          </div>
          <div className="flex gap-2 pt-2">
            <button
              onClick={() => onOpenChange(false)}
              disabled={creating}
              className="flex-1 rounded-md border border-stone-200 px-4 py-2.5 text-sm font-medium text-stone-700 hover:bg-stone-50"
              data-testid="create-trip-cancel-btn"
            >
              Avbryt
            </button>
            <button
              onClick={onSubmit}
              disabled={creating || !form.name.trim()}
              className="flex-1 rounded-md bg-navy-800 hover:bg-navy-900 px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-50"
              data-testid="create-trip-confirm-btn"
            >
              {creating ? "Oppretter…" : "Opprett"}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
